import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './JoinDebateControls.module.css';
import Button from '../../ui/Button';
import { debateTypes } from '../debateFormatsDataV3';
const JoinDebateControls = ({ user, arena, onJoin }) => {
  const { t } = useTranslation();

  const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
  
  var isModeratorValid = meta?.roles?.judge?.exists === true || meta?.roles?.moderator?.exists === true || false;
  var isModerator = false;
  if(isModeratorValid) {
	  isModerator = arena?.roles?.moderator?.uid === user?.uid;
  }

  const isDebater = arena.roles?.debaters?.some(d => d?.uid === user.uid);
  //const isSpectator = !isModerator && !isDebater;
  const isSpectator = arena?.spectators?.find(s => s.uid === user.uid) || false;


  const gov = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[0]);
  const opp = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[1]);

  const totalSlots = arena?.custom?.participants || 0;
  const teamCount = arena?.custom?.teams?.length || 0;

  const debaterSlots = arena.roles.debaters || [];
  const hasModeratorSlot = !arena.roles.moderator?.uid;
  const NoSpectators = arena?.spectators?.length || 0;
  const NoDebaters = arena?.custom?.participants || 0;
  const isSpaceLeft = debaterSlots?.length < NoDebaters;
  //console.log(meta.rules.spectatorsContribute)
  
  /*const availableTeamIndices = arena.custom.teams.map((teamName, teamIdx) => {

	const start = arena.custom.teamsnumber.slice(0, teamIdx).reduce((sum, n) => sum + n, 0);
    const teamSlots = arena.custom.teamsnumber[teamIdx];
    const teamFilled = debaterSlots.slice(start, start + teamSlots).filter(Boolean).length;
	    console.log(teamName, teamIdx, teamSlots, teamFilled)
    return teamFilled < teamSlots ? teamIdx : null;
  }).filter(idx => idx !== null);*/

	const availableTeamIndices = arena.custom.teams.map((teamName, teamIdx) => {
	  const teamSlots = arena.custom.teamsnumber[teamIdx];

	  const teamFilled = arena.roles.debaters.filter(
		(d) => d?.team === teamName && d?.uid
	  ).length;

	  return teamFilled < teamSlots ? teamIdx : null;
	}).filter(idx => idx !== null);
	
  //console.log(NoSpectators, isSpectator, arena?.spectators, user.uid, hasModeratorSlot, debaterSlots, availableTeamIndices)

	if(isDebater || isModerator || isSpectator || NoSpectators > 100 || !meta?.spectators?.canParticipate ) return null;

  return (
    <div className={styles.joinControls}>
      {/*<h3>{t('ui.joinThisDebate')}:</h3>*/}

      {isDebater && <p>{t('ui.youAreDebater')}</p>}
      {isModerator && <p>{t('ui.youAreModerator')}</p>}
      {isSpectator && <p>{t('ui.youAreSpectating')}</p>}

      {!isDebater && !isModerator && !isSpectator && isSpaceLeft == true && availableTeamIndices.map(teamIdx => {
        const team = arena.custom.teams[teamIdx];
		    const teamno = arena.custom.teamsnumber[teamIdx];
		    const base = Math.floor(totalSlots / teamCount);
		    const opp = arena?.roles?.debaters.filter(d => d?.team === team);
		
		
		//console.log(teamno, base, opp.length)
		if(base <= opp.length) return null;
		
        return (
          <Button
            key={teamIdx}
            className={styles.joinBtn}
            variant="primary"
            onClick={(e) => { e.stopPropagation(); onJoin('debater', teamIdx, arena.id);}}>
            Join as {team}
          </Button>
        );
      })}

      {!isDebater && isModeratorValid && !isModerator && !isSpectator && hasModeratorSlot && (
        <Button
          className={styles.joinBtn}
          variant="primary"
          onClick={(e) => { e.stopPropagation(); onJoin('moderator', null, arena.id);}}>
          Join as Moderator
        </Button>
      )}

      {!isDebater && !isModerator && !isSpectator && NoSpectators < 100 && meta?.spectators?.canParticipate && (
        <Button
          className={styles.joinBtn}
          variant="secondary"
          onClick={(e) => { e.stopPropagation(); onJoin('spectator', null, arena.id);}}>
          Watch as Spectator
        </Button>
      )}
    </div>
  );
};

export default JoinDebateControls;
